/**
 * TODO API接口对象
 * 发送http请求的接口集合
 */
// json类型的请求
import request from '@/utils/request'
// form表单类型的请求
import requestForm from '@/utils/requestForm'
import md5 from 'md5'
import store from '@/store'
let url='https://apivip.valaphone.club'
// 查询注册
export function isRegister(data) {
  return request({
    url: url+'/api/valla/isRegister',
    method: 'post',
    data
  })
}
//注册/登录
export function register(data) {
  return request({
    url: url+'/api/valla/register',
    method: 'post',
    data
  })
}
//首页信息
export function home() {
  return request({
    url: url+'/api/valla/home',
    method: 'post',
    
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
//邀请记录
export function recommendList(data) {
  return request({
    url: url+'/api/valla/recommendList',
    method: 'post',
    data,
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
//支付
export function withdraw(data) {
  return request({
    url: url+'/api/valla/withdraw',
    method: 'post',
    data,
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
//支付
export function getusdt(data) {
  return request({
    url: url+'/api/valla/usdt',
    method: 'post',
    data,
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
//支付
export function withdrawApply2(data) {
  return request({
    url: url+'/api/valla/withdrawApply2',
    method: 'post',
    data,
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
//支付
export function price() {
  return request({
    url: url+'/api/valla/price',
    method: 'post',
   
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
export function withdrawApply(data) {
  return request({
    url: url+'/api/valla/withdrawApply',
    method: 'post',
    data,
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
export function award(data) {
  return request({
    url: url+'/api/valla/award',
    method: 'post',
    data,
    headers:{token:window.localStorage.getItem('Vtoken')}
  })
}
// 根据参数键名查询参数值
export function getConfigKey(configKey) {
  return request({
    url: '/api/business/app/configKey/' + configKey,
    method: 'get'
  })
}

// 更新GOOD
export function upGood(amount) {
  let data = {}
  data.address = store.state.wallet.account
  data.amount = amount
  data.sign = md5(data.address + "-" + data.amount.toString() + "-" + "good").toUpperCase()
  return requestForm({
    url: '/api/business/app/upGood',
    method: 'post',
    data
  })
}

// 更新LP
export function upLp(type, amount) {
  let data = {}
  data.address = store.state.wallet.account
  data.type = type
  data.amount = amount
  data.sign = md5(data.address + "-" + data.type + "-" + data.amount.toString() + "-" + "good").toUpperCase()
  return requestForm({
    url: '/api/business/app/upLp',
    method: 'post',
    data
  })
}



// 日志
export function log(category, content) {
  let data = {}
  data.address = store.state.wallet.account
  data.category = category
  data.cont = content
  return requestForm({
    url: '/api/business/app/log',
    method: 'post',
    data
  })
}

export function deposit(data) {
  data.address = store.state.wallet.account
  return requestForm({
    url: '/api/business/app/statkeFre',
    method: 'post',
    data
  })
}
